import { Injectable, inject } from '@angular/core';
import { NgxLoggerLevel } from 'ngx-logger';
import { environment } from '../../../environments/environment';

/*
export enum NgxLoggerLevel {
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  LOG = 3,
  WARN = 4,
  ERROR = 5,
  FATAL = 6,
  OFF = 7
}
*/

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  // Determine the logging level based on Environment configuration - to be used by ngx-logger
  getLoggerLevel(): NgxLoggerLevel {
    // console.log('getLoggerLevel()', environment.logLevel?.toUpperCase());
    switch (environment.logLevel?.toUpperCase()) {
      case 'TRACE': return NgxLoggerLevel.TRACE;
      case 'DEBUG': return NgxLoggerLevel.DEBUG;
      case 'INFO': return NgxLoggerLevel.INFO;
      case 'LOG': return NgxLoggerLevel.LOG;
      case 'WARN': return NgxLoggerLevel.WARN;
      case 'ERROR': return NgxLoggerLevel.ERROR;
      case 'FATAL': return NgxLoggerLevel.FATAL;
      default: return NgxLoggerLevel.OFF;
    }
  }

}

